__turbopack_context__.v({
  "container": "ErrorLayout-module-scss-module__cskhbG__container",
  "image": "ErrorLayout-module-scss-module__cskhbG__image",
  "message": "ErrorLayout-module-scss-module__cskhbG__message",
  "title": "ErrorLayout-module-scss-module__cskhbG__title",
});
